import { render, staticRenderFns } from "./BillingAdminInvoiceTable.vue?vue&type=template&id=23d070fa&scoped=true&"
import script from "./BillingAdminInvoiceTable.vue?vue&type=script&lang=js&"
export * from "./BillingAdminInvoiceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d070fa",
  null
  
)

export default component.exports